import { Ditto } from '@ow/ditto-core'
import * as DtDefault from '../fields/default'
import * as DtText from '../fields/text'
import * as DtRichText from '../fields/richText'
import * as DtBatchText from '../fields/batchText'
import * as DtNumber from '../fields/number'
import * as DtDatetime from '../fields/datetime'
import * as DtMedia from '../fields/media'
import * as DtAttachment from '../fields/attachment'
import * as DtBoolean from '../fields/boolean'
import * as DtGeolocation from '../fields/geolocation'
import * as DtGis from '../fields/gis'
import * as DtUser from '../fields/user'
import * as DtOrg from '../fields/org'
import * as DtArea from '../fields/area'
import * as DtStandard from '../fields/standard'
import * as DtDropSelect from '../fields/dropselect'
import * as DtSelection from '../fields/selection'
import * as DtIdentifier from '../fields/identifier'
import * as DtOperate from '../fields/operate'
import * as DtRef from '../fields/ref'
import * as DtLookup from '../fields/lookup'
import * as DtButton from '../fields/button'
import * as DtProduct from '../fields/product'
import * as DtStatistics from '../fields/statistics'

export const ditto = new Ditto()

ditto.registeWidget('default', { transformer: DtDefault.transformer })
ditto.registeWidget('text', {
  transformer: DtText.transformer,
})
ditto.registeWidget('richText', {
  transformer: DtRichText.transformer,
})
ditto.registeWidget('batchText', {
  transformer: DtBatchText.transformer,
})
ditto.registeWidget('number', {
  transformer: DtNumber.transformer,
})
ditto.registeWidget('datetime', {
  transformer: DtDatetime.transformer,
})
ditto.registeWidget('media', {
  transformer: DtMedia.transformer,
})
ditto.registeWidget('attachment', {
  transformer: DtAttachment.transformer,
})
ditto.registeWidget('boolean', {
  transformer: DtBoolean.transformer,
})
ditto.registeWidget('gis', {
  transformer: DtGis.transformer,
})
ditto.registeWidget('geolocation', {
  transformer: DtGeolocation.transformer,
})
ditto.registeWidget('org', {
  transformer: DtOrg.transformer,
})
ditto.registeWidget('orgMultiple', {
  transformer: DtOrg.transformer,
})
ditto.registeWidget('user', {
  transformer: DtUser.transformer,
})
ditto.registeWidget('userMultiple', {
  transformer: DtUser.transformer,
})
ditto.registeWidget('area', {
  transformer: DtArea.transformer,
})
ditto.registeWidget('standard', {
  transformer: DtStandard.transformer,
})
ditto.registeWidget('dropSelect', {
  transformer: DtDropSelect.transformer,
})
ditto.registeWidget('array', {
  transformer: DtDropSelect.transformer,
})
ditto.registeWidget('selection', {
  transformer: DtSelection.transformer,
})
ditto.registeWidget('identifier', {
  transformer: DtIdentifier.transformer,
})
ditto.registeWidget('operate', {
  transformer: DtOperate.transformer,
})
ditto.registeWidget('ref', {
  transformer: DtRef.transformer,
})
ditto.registeWidget('sysref', {
  transformer: DtRef.transformer,
})
ditto.registeWidget('lookup', {
  transformer: DtLookup.transformer,
})
ditto.registeWidget('button', {
  transformer: DtButton.transformer,
})
ditto.registeWidget('product', {
  transformer: DtProduct.transformer,
})
ditto.registeWidget('statistics', {
  transformer: DtStatistics.transformer,
})
export default ditto
